import type { CalendarReplacementDto } from '@bhops/shared';

// 로봇 교체 일정의 칩 · 목록 표기(2026-10-20) — 통합 캘린더와 '다가오는 일정'이 같은 말을 쓴다.
// 여러 대를 한 일정으로 교체하면 제목에 대수, 설명에 로봇마다 `#907 → #920`(넣을 로봇이 아직이면 '배정 전').

/** '그린리조트' · 여러 대면 '그린리조트 (3대)'. */
export function replacementTitle(r: CalendarReplacementDto): string {
  return r.items.length > 1 ? `${r.customerName} (${r.items.length}대)` : r.customerName;
}

/** '#907 → #920' · '교체 완료 · #907 → #920' · 여러 대면 '1/3대 교체 완료 · #901 → #921, #902 → 배정 전 …'. */
export function replacementSubtitle(r: CalendarReplacementDto): string {
  const pairs = r.items
    .map((i) => `${i.oldRobot.label} → ${i.newRobot?.label ?? '배정 전'}`)
    .join(', ');
  const doneCount = r.items.filter((i) => i.done).length;
  const head =
    r.items.length > 1
      ? doneCount > 0
        ? `${doneCount}/${r.items.length}대 교체 완료 · `
        : ''
      : r.done
        ? '교체 완료 · '
        : '';
  return `${head}${pairs}`;
}
